import { ContactUsPage } from 'components/ContactUsPage';
import Layout from 'components/Layout';
import React, { useEffect } from 'react';
import track from 'utils/analytics/track';
import { ANALYTICS } from 'utils/constants/analytics';

import { SEO } from '../components/SEO';

export const Head = () => <SEO />;

export const contactUsPage = () => {
  useEffect(() => {
    track({
      event: ANALYTICS.EVENTS.VIEWED_EHS_PAGE,
      data: {
        label: 'EHS Contact US page',
      },
    });
  }, []);

  return (
    <Layout>
      <ContactUsPage />
    </Layout>
  );
};

export default contactUsPage;
